<ng-container *ngIf="{ legalDocumentStorage: legalDocumentsBloc.legalDocumentStorage$ | async } as observables">
  <div class="privacy-screen">
    <div class="privacy">
      <h1 class="title">Privacy Pledge</h1>
      <ng-container *ngIf="observables.legalDocumentStorage?.privacy?.data?.summary as summary; else loading">
        <p class="summary">{{ summary }}</p>
        <div class="privacy-full-notice" *ngIf="requireAcceptance">
          <kp-checkbox class="checkbox" (check)="privacyCheckboxChanged($event)">
            I have read and accept the
            <button class="full-policy" (click)="clickFullPolicyLink($event, legalDocumentType.PRIVACY)">
              privacy policy
            </button>
            and
            <button class="full-policy" (click)="clickFullPolicyLink($event, legalDocumentType.EULA)">
              acceptable use policy
            </button>
          </kp-checkbox>
        </div>
        <button
          class="button button-pill"
          [disabled]="!summary || (requireAcceptance && !fullPolicyAccepted) || acceptInProgress || !statusChecked"
          type="submit"
          (click)="continue()">
          Continue
        </button>
      </ng-container>
    </div>
  </div>
  <ng-template #loading>
    <div>
      <kp-shimmer class="w95"></kp-shimmer>
      <kp-shimmer class="w100"></kp-shimmer>
      <kp-shimmer class="w92"></kp-shimmer>
      <kp-shimmer class="w80"></kp-shimmer>
      <br />
      <br />
      <kp-shimmer class="w100"></kp-shimmer>
      <kp-shimmer class="w92"></kp-shimmer>
      <kp-shimmer class="w95"></kp-shimmer>
      <kp-shimmer class="w87"></kp-shimmer>
      <kp-shimmer class="w75"></kp-shimmer>
    </div>
  </ng-template>

  <kui-modal
    *ngIf="showFullPolicy && policyType === legalDocumentType.PRIVACY"
    [isOpen]="showFullPolicy && policyType === legalDocumentType.PRIVACY"
    [html]="observables.legalDocumentStorage?.privacy?.data?.contentAsParsedHtml"
    type="legal"
    (isOpenChange)="isFullPolicyOpen($event)"></kui-modal>

  <kui-modal
    *ngIf="showFullPolicy && policyType === legalDocumentType.EULA"
    [isOpen]="showFullPolicy && policyType === legalDocumentType.EULA"
    [html]="observables.legalDocumentStorage?.eula?.data?.contentAsParsedHtml"
    type="legal"
    (isOpenChange)="isFullPolicyOpen($event)"></kui-modal>
</ng-container>
